// Which side of a diff a source lookup addresses. EDIT is the working branch in both comparisons;
// REVIEW is the branch each comparison is measured against — the REVIEW branch in the EDIT Branch
// Comparison, MAIN in the MAIN Branch Comparison.
export const PROVENANCE_PERSPECTIVE = {
    EDIT: 'EDIT',
    REVIEW: 'REVIEW',
} as const;

export const REVIEW_STATUS = {
    REJECTED: 'REJECTED',
    APPROVED: 'APPROVED',
    IN_PROGRESS: 'IN_PROGRESS',
    APPROVAL_AUTO_REJECTED: 'APPROVAL_AUTO_REJECTED',
    PENDING_REVISION: 'PENDING_REVISION',
    DISCONTINUED: 'DISCONTINUED',
} as const;
